export default __webpack_public_path__ + "static/media/steeltype.f7ff7bfd.svg";